import React, { useEffect, useState } from 'react';
import { Crown, ArrowRight, X } from 'lucide-react';

const DISMISS_KEY = 'avenuear_claim_banner_dismissed_v1';

export default function ClaimBanner({ onClaimClick }) {
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    // Stay hidden if the visitor has dismissed this banner before.
    try {
      const dismissed = localStorage.getItem(DISMISS_KEY);
      setHidden(dismissed === '1');
    } catch {
      setHidden(false);
    }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* ignore */ }
    setHidden(true);
  };

  if (hidden) return null;

  return (
    <div
      className="sticky top-0 z-40 w-full bg-avenue-carbon border-b border-avenue-red"
      data-testid="claim-banner"
    >
      <div className="max-w-avenue mx-auto flex items-center justify-between gap-3 px-4 sm:px-6 py-2.5">
        <div className="flex items-center gap-3 min-w-0">
          <span className="hidden sm:inline-flex items-center justify-center w-7 h-7 border border-avenue-red/50 shrink-0">
            <Crown className="w-3.5 h-3.5 text-avenue-red" />
          </span>
          <p className="text-sm text-avenue-white/80 leading-snug truncate">
            <strong className="text-avenue-red font-medium uppercase tracking-[0.12em]">Founding Member?</strong>
            <span className="hidden sm:inline">
              {' '}Claim your locked-rate account — founding perks locked for life.
            </span>
            <span className="sm:hidden"> Claim your locked-rate account.</span>
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={onClaimClick}
            className="inline-flex items-center gap-1.5 px-3 sm:px-4 py-1.5 bg-avenue-red text-white text-xs font-medium uppercase tracking-wider hover:bg-avenue-electric-red transition-colors duration-300"
            data-testid="claim-banner-cta"
          >
            Claim now
            <ArrowRight className="w-3.5 h-3.5" />
          </button>
          <button
            onClick={dismiss}
            className="p-1 text-avenue-white/50 hover:text-avenue-white transition-colors duration-300"
            aria-label="Dismiss"
            data-testid="claim-banner-dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
